import { CSSObject } from '@mantine/core';
import { MantineThemeComponent } from '../../types';
import { textVariants } from '../../tokens/typography/typography';

const MenuDefaultConfig: MantineThemeComponent = {
	styles: theme => ( {
		inner: {
			padding: 0
		},
		dropdown: {
			backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[ 5 ] : 'var(--color-bg-container)',
			borderColor: 'var(--color-outline-default)'
		},
		item: {
			'padding': '4px 24px 4px 12px',
			'color': 'var(--color-text-primary)',
			'&[data-hovered]': {
				backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[ 4 ] : 'var(--color-primary-subtle)',
				color: 'var(--color-text-primary)'
			},
			'&[data-disabled]': {
				color: 'var(--color-text-light)'
			},
			...( textVariants[ 'footnote-semibold' ] as CSSObject )
		},
		itemIcon: {
			marginRight: '6px'
		}
	} )
};

export default MenuDefaultConfig;
